// import componenti
import ListaUtenti, { isCessato } from "../../components/ListaUtenti";

// import hooks
import { useCollection } from "../../hooks/useCollection";
// import { useAuthContext } from "../../hooks/useAuthContext";

// import pacchetti
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// import styles
import "./Dashboard.css";

export default function GestioneUtenti() {
  // const navigazione = useNavigate();
  // const { user } = useAuthContext();
  const { documents, error } = useCollection("users");
  const [ricerca, setRicerca] = useState("");
  const [settoreFiltro, setSettoreFiltro] = useState("tutti");
  const [ordinaPer, setOrdinaPer] = useState("settore");
  const [nascondiCessati, setNascondiCessati] = useState(true);

  const nomeUtente = (utente) =>
    utente.anagrafica
      ? `${utente.anagrafica.nome || ""} ${utente.anagrafica.cognome || ""}`.trim()
      : utente.displayName || "";

  // Settori presenti negli utenti, per popolare il filtro
  const settoriDisponibili = useMemo(() => {
    if (!documents) return [];
    const settori = new Set();
    documents.forEach((utente) => {
      const settore = utente.anagrafica?.settore;
      if (settore) settori.add(settore);
    });
    return Array.from(settori).sort((a, b) => a.localeCompare(b));
  }, [documents]);

  // Lista utenti filtrata e ordinata
  const utentiVisibili = useMemo(() => {
    if (!documents) return [];
    const termine = ricerca.trim().toLowerCase();

    const filtrati = documents.filter((utente) => {
      // Nascondi gli ex dipendenti
      if (nascondiCessati && isCessato(utente)) return false;

      // Filtro per settore
      if (
        settoreFiltro !== "tutti" &&
        utente.anagrafica?.settore !== settoreFiltro
      ) {
        return false;
      }

      // Ricerca testuale
      if (!termine) return true;
      const displayName = (utente.displayName || "").toLowerCase();
      const nome = (utente.anagrafica?.nome || "").toLowerCase();
      const cognome = (utente.anagrafica?.cognome || "").toLowerCase();
      return (
        displayName.includes(termine) ||
        nome.includes(termine) ||
        cognome.includes(termine) ||
        `${nome} ${cognome}`.includes(termine)
      );
    });

    return [...filtrati].sort((a, b) => {
      if (ordinaPer === "settore") {
        const settoreA = a.anagrafica?.settore || "";
        const settoreB = b.anagrafica?.settore || "";
        const confronto = settoreA.localeCompare(settoreB);
        if (confronto !== 0) return confronto;
      }
      return nomeUtente(a).localeCompare(nomeUtente(b));
    });
  }, [documents, ricerca, settoreFiltro, ordinaPer, nascondiCessati]);

  return (
    <div>
      <div className="title-container">
        <h2 className="page-title">Dipendenti</h2>
        <div className="controls-container">
          <input
            type="text"
            value={ricerca}
            onChange={(e) => setRicerca(e.target.value)}
            placeholder="Cerca"
            className="search-bar"
          />
          <Link to="/docUpdate" className="btn">
            Aggiorna Documenti
          </Link>
          <Link to="/documentiUtenti" className="btn">
            Documenti Utenti
          </Link>
        </div>
      </div>

      <div className="filtri-utenti">
        <label>
          <span>Settore:</span>
          <select
            value={settoreFiltro}
            onChange={(e) => setSettoreFiltro(e.target.value)}
          >
            <option value="tutti">Tutti i settori</option>
            {settoriDisponibili.map((settore) => (
              <option key={settore} value={settore}>
                {settore}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>Ordina per:</span>
          <select
            value={ordinaPer}
            onChange={(e) => setOrdinaPer(e.target.value)}
          >
            <option value="settore">Settore</option>
            <option value="nome">Nome</option>
          </select>
        </label>

        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={nascondiCessati}
            onChange={(e) => setNascondiCessati(e.target.checked)}
          />
          <span>Nascondi ex dipendenti</span>
        </label>
      </div>

      {error && <p className="error">{error}</p>}

      {documents && <ListaUtenti data={utentiVisibili} />}
    </div>
  );
}
